import { SlugNameService } from './../../Services/slug-name.service';
import { LoginUsersService } from "src/app/Services/login-users.service";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { EmbryoService } from "src/app/Services/Embryo.service";
import { ReactivityService } from "../../Services/reactivity.service";
import { TranslateService } from "@ngx-translate/core";
import { HomePageService } from "../../Services/home-page.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { StaticPagesService } from "src/app/Services/static-pages.service";
import Swal from "sweetalert2";
import { MetaService } from "src/app/Services/meta-data.service";

@Component({
    selector: "app-compare-product",
    templateUrl: "./compare-product.component.html",
    styleUrls: ["./compare-product.component.scss"],
})
export class CompareProductComponent implements OnInit, OnDestroy {
    products: Array<any> = [];
    specification: string[] = [];
    lang: any;
    isAuthUser: any;
    toggleLoading: boolean = false;
    productId: any;
    user: any;
    compareListProducts: any;
    toggleCartLoading: boolean = false;
    environmentVariables: any;
    redirectToProduct: boolean = false;
    homeSubscription: any;

    constructor(
        public embryoService: EmbryoService,
        private reactivityService: ReactivityService,
        private translate: TranslateService,
        private homePageService: HomePageService,
        public userLoginServies: LoginUsersService,
        public snackBar: MatSnackBar,
        private router: Router,
        private confgServ: StaticPagesService,
        private metaService: MetaService,
				private slugNameService:SlugNameService,
    ) {
        this.confgServ.getenvConfig().subscribe((res) => {
            this.environmentVariables = res;
            this.redirectToProduct =
                this.environmentVariables?.PRODUCT_TYPE == "main";
        });

        embryoService.emitLang.subscribe((lang: string) => {
            translate.setDefaultLang(lang);
            this.lang = lang;
            if (this.lang == "en")
                this.metaService.setTitle(
                    `Compare - ${this.environmentVariables?.APP_NAME}`
                );
            else
                this.metaService.setTitle(
                    `مقارنه - ${this.environmentVariables?.APP_NAME_AR}`
                );
            this.getCompareList();
        });
    }

    ngOnInit() {
        this.homeSubscription = this.homePageService.isInitLoading.subscribe(
            (value) => {
                if (value) {
                    this.toggleLoading = true;
                } else {
                    this.toggleLoading = false;
                }
            }
        );

        this.embryoService.compareListSub.subscribe((res) => {
            if (this.userLoginServies.isGuest()) {
                this.products = res;
            }
        });
        this.isAuthUser = JSON.parse(
            <string>localStorage.getItem("auth_user_crocs")
        );
        this.lang = localStorage.getItem("lang");
        this.getCompareList();
    }

    getCompareList() {
        this.toggleLoading = true;
        this.specification = [];
        // if (!this.userLoginServies.isGuest()) {
            this.homePageService.getCompareList().subscribe(
                (res: any) => {
                    if (res.code === 200) {
                        this.toggleLoading = false;
                        this.products = res.data || [];
                        this.prepareData();
                    } else {
                        this.toggleLoading = false;
                        Swal.fire({
                            html: `<p style='color:white'>${res.message}</p>`,
                            width: 250,
                            position: "bottom-end",
                            background: "#bd362f",
                            timerProgressBar: true,
                            showConfirmButton: false,
                            timer: 3000,
                            backdrop: false,
                            allowOutsideClick: true,
                        });
                    }
                },
                () => (this.toggleLoading = false)
            );
        // } else {
        //     this.products =
        //         JSON.parse(<string>localStorage.getItem("compareItems")) ||
        //         this.compareListProducts ||
        //         [];
        //     this.prepareData();
        //     this.toggleLoading = false;
        // }
    }

    prepareData() {
        this.products.forEach((item: any) => {
            item.slug_name = this.getProductName(item);
            item.editName = item.name.replace(/\s/g, "-");
            item.details.attributes.forEach((spec: any) => {
                if (!this.specification.includes(spec.option.toUpperCase())) {
                    this.specification.push(spec.option.toUpperCase());
                }
            });
        });
    }
    getProductName(product: any) {
        // const nameRouting = product.name_en
        //     .replace(/[^\w\s]/gi, "-")
        //     .replace(/ /g, "-");
        // const parentId = product.parent_id || product.id;
        // return nameRouting + "/" + parentId;
				return this.slugNameService.getProductName(product);
    }
    removeProduct(product: any, index: number) {
        this.productId = product.id;
        // if (!this.userLoginServies.isGuest()) {
            product["loading"] = true;

            this.homePageService
                .removeFromCompareList(this.productId)
                .subscribe(
                    (res: any) => {
                        if (res.code === 200) {
                            this.products.splice(index, 1);
                            this.reactivityService.setDataToStore(
                                "removeProductFromCompare",
                                product
                            );
                        } else {
                            Swal.fire({
                                html: `<p style='color:white'>${res.message}</p>`,
                                width: 250,
                                position: "bottom-end",
                                background: "#bd362f",
                                timerProgressBar: true,
                                showConfirmButton: false,
                                timer: 3000,
                                backdrop: false,
                                allowOutsideClick: true,
                            });
                        }
                        product["loading"] = false;
                    },
                    () => (product["loading"] = false)
                );
        // } else {
        //     this.embryoService.removeProductFromCompareGuest(product);
        // }
    }

    getAttributeValue(attributes: [{ option: any; value: any }], spec: any) {
        const result = attributes.filter(
            (item) => item.option.toUpperCase() == spec
        )[0];
        return result ? result.value : this.lang == 'en' ? `<span class=\"no-data\">No Data</span>` : `<span class=\"no-data\">لا يوجد معلومات</span>`;
    }

    ngOnDestroy() {
        this.homeSubscription?.unsubscribe();
    }

		redirectToProductFun(product:any){
			const parentId = product?.parent_id || product?.id;
			if (product?.slug) {
				this.router.navigate(
					["/" + this.lang + "/products", product?.slug],
					// {
					// 		state: { name: product?.slug },
					// 		queryParams: { variant: product.id },
					// }
				);
			}
			else{
				const nameRouting = product.name_en
					.replace(/[^\w\s]/gi, "-")
					.replace(/ /g, "-");
					this.router.navigate(
						["/" + this.lang + "/products", product?.slug],
						// {
						// 		state: { name: nameRouting },
						// 		queryParams: { variant: product.id },
						// }
					);
			}
		}
}
